const columns = [
	{
		id: 'contact_id',
		name: 'ID',
		selector: row => row.contact_id,
		cell: row => row.contact_id,
		visible: false
	}, {
		id: 'contact_name',
		name: 'Name',
		selector: row => row.contact_name,
		cell: row => row.contact_name,
		width: '1fr',
		isFirstVisible: true
	}, {
		id: 'account_name',
		name: 'Account Name',
		sortable: true,
		selector: row => row.account_name,
		cell: row => row.account_name,
		width: '1fr'
	}, {
		id: 'title',
		name: 'Title',
		selector: row => row.title,
		cell: row => row.title,
		width: '1fr'
	}, {
		id: 'segment',
		name: 'Segment',
		selector: row => row.segment,
		cell: row => row.segment,
		width: '1fr'
	}, {
		id: 'accounts_type_name',
		name: 'Account Type',
		selector: row => row.accounts_type_name,
		cell: row => row.accounts_type_name,
		width: '1fr'
	}, {
		id: 'contact_email',
		name: 'Email',
		selector: row => row.contact_email,
		cell: row => row.contact_email,
		width: '1fr'
	}, {
		id: 'reports_to',
		name: 'Reports To',
		selector: row => row.reports_to,
		cell: row => row.reports_to,
		width: '1fr'
	},
];

export default columns;
